import { clsx } from 'clsx';

import { UniversalImage } from '@monoimin/atoms';

import { CardProps } from '@monoimin/sb-types';

import CardTitleAndDescription from './CardTitleAndDescription';
import CardFooter from './CardFooter';

export const VARIANT_CLASSES: {
  [variant in NonNullable<CardProps['variant']>]:
    | {
        title?: string;
        container?: string;
        image?: string;
        content?: string;
        overtitle?: string;
      }
    | undefined;
} = {
  default: {
    container: 'flex-col border border-line',
    title: 'body',
    image: 'min-h-56',
    content: ' p-5 md:p-7',
  },
  large: {
    container: 'flex-col border border-line',
    title: 'h3 mb-2',
    image: 'min-h-56 md:min-h-80',
    content: ' px-5 p-5 md:p-7',
  },
  horizontal: {
    container: 'flex-col md:flex-row border border-line',
    title: 'text-body-xl xl:text-h2-xl md:text-h2-md mb-2 md:mb-4',
    image: 'w-full md:w-1/2',
    content: ' p-5 md:p-7',
  },
  custom: undefined,
};

export function Card(props: CardProps) {
  const {
    title,
    priority,
    variant = 'default',
    classNames,
    imageUrl,
    sizes = '(max-width: 768px) 95vw, 23vw',
    onClick,
  } = props;

  return (
    <div
      data-clickable='true'
      className={clsx(
        'card-container overflow-hidden group relative select-none bg-white flex w-full',
        VARIANT_CLASSES[variant]?.container,
        classNames?.container
      )}
      onClick={onClick}
      role='button'
      tabIndex={0}
      data-testid='card'
    >
      {imageUrl && (
        <UniversalImage
          pattern='fill'
          src={imageUrl}
          containerClassName={clsx(
            'skeleton overflow-hidden aspect-video',
            VARIANT_CLASSES[variant]?.image,
            classNames?.image
          )}
          className='card-image pointer-events-none object-cover duration-300 group-hover:scale-105 shrink-0'
          sizes={sizes}
          alt={title}
          priority={priority}
        />
      )}
      <div
        className={clsx(
          'card-content flex flex-col justify-between flex-1',
          VARIANT_CLASSES[variant]?.content,
          classNames?.content
        )}
      >
        <CardTitleAndDescription
          {...props}
          classNames={{
            ...props.classNames,
            title: clsx(
              VARIANT_CLASSES[variant]?.title,
              props.classNames?.title
            ),
          }}
        />
        <CardFooter {...props} />
      </div>
    </div>
  );
}
export default Card;
